module.exports = __webpack_public_path__ + "static/media/spinner.e29a0408.svg";